<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Upload Specification Update
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div>Below is the manifest:</div>
        <div>
          {{ JSON.stringify(manifest) }}
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="indigo" class="white--text" @click="onConfirmClick()" v-if="filterValid">Confirm</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    tmpPath: String,
    manifest: Object,
  },

  data() {
    return {
      active: true,
      targetFamily: 'all',
      filter: '*',
      filterArray: ['*'],
      filterValid: true,

      targetFamilySelection: ['all', 'aligner', 'gtps', 'aligner-oasis'],
    };
  },

  methods: {
    onCancelClick() {
      this.$emit('close', false);
    },

    onConfirmClick() {
    },
  },
};
</script>
